import {
  Box,
  FormHelperText,
  Grid,
  Paper,
  Typography,
  useMediaQuery,
} from '@mui/material';
import { Label } from 'components/DividaItem/styles';
import React, {
  useEffect,
  useMemo, useState
} from 'react';
import { When } from 'react-if';
import { useTheme } from 'styled-components';
import {
  TIPO_DESCONTO_MOMETARIO,
  TIPO_DESCONTO_PERCENTUAL,
} from 'utils/constants';
import { formatToPercent, getFormattedDate, getMoney, moneyAndPercent } from 'utils/transform';
import ChipAvista from './ChipAvista';
import ChipInsurance from './ChipInsurance';
import { IOpcaoPagamento } from 'interfaces/BuscaOpcaoPagamento';

export function getNumberWithTwoDecimals(number: any) {
  return Math.round((number + Number.EPSILON) * 100) / 100;
}

function formatDesconto(desconto: any, tipoDesconto: any) {
  if (tipoDesconto === TIPO_DESCONTO_PERCENTUAL)
    return formatToPercent(desconto);

  if (tipoDesconto === TIPO_DESCONTO_MOMETARIO) return getMoney(desconto);
}

function ListaParcelamento({
  options = [],
  opcao,
  onChange,
  value,
  showError = false,
  divida = {},
}: any) {
  const theme = useTheme();
  const isMobile = useMediaQuery((theme: any) => theme.breakpoints.down('sm'));
  const [optionsToShow, setOptionsToShow] = useState<IOpcaoPagamento[]>([]);

  const exibirDescontoMonetario = divida.exibirDescontoMonetario;
  const exibirDescontoPercentual = divida.exibirDescontoPercentual;

  function mostrarValorDesconto(descontoMonetario: any, descontoPercentual: any) {
    return (exibirDescontoPercentual && !!descontoPercentual) || (exibirDescontoMonetario && !!descontoMonetario);
  }

  function valorDesconto(monetario:any, percentual:any){
    if (!opcao) return;

    if (exibirDescontoPercentual && !exibirDescontoMonetario) {
      return formatToPercent(percentual);
    }

    if (!exibirDescontoPercentual && exibirDescontoMonetario) {
      return getMoney(monetario);
    }

    if (exibirDescontoPercentual && exibirDescontoMonetario) {
      return (
        ''+
        (moneyAndPercent(monetario,percentual)[0])
        +' ('+
        (moneyAndPercent(monetario,percentual)[1])
        +')'
      )
    }
  }

  useEffect(() => {
    if (!!opcao?.opcoesParcelamentoExibir?.length) {
      setOptionsToShow(options.filter((option: IOpcaoPagamento) =>
       opcao?.opcoesParcelamentoExibir.includes(option.qtdParcelas)))

      return;
    }

    setOptionsToShow(options);
  }, []);

  return (
    <Grid
      container
      direction="column"
      justifyContent="space-between"
      alignItems="stretch"
      spacing={2}
    >
      {optionsToShow.map((opcaoPagamento: IOpcaoPagamento, parcelaIndex: any) => {
        const selected = value?.codigo === opcaoPagamento.codigo;
        return (
          <Grid style={{ height: '100%' }} item key={opcaoPagamento?.codigo}>
            <Paper
              onClick={() => onChange(opcaoPagamento)}
              elevation={0}
              style={{
                cursor: 'pointer',
                borderColor: selected
                  // @ts-ignore
                  ? theme.palette.secondary.main
                  : '#D3D3D3',
                borderWidth: selected ? 2 : 1,
              }}
              variant="outlined"
            >
              <Box
                px={2}
                style={{
                  height: '100%',
                  display: 'flex',
                  alignItems: 'center',
                  position: 'relative',
                }}
              >
                {divida?.tipoContrato === "REORGPF" ? (
                  <ChipInsurance withInsurance={opcaoPagamento.opcaoComSeguro} />
                ) : (
                  (!!opcaoPagamento.opcaoMaisEconomica) && (
                    <ChipAvista />
                  )
                )}
              </Box>
              <Grid
                container
                direction="row"
                justifyContent="center"
                alignItems="center"
                spacing={0}
              >
                <Grid item xs={12}>
                  <Box marginX={1} marginY={2}>
                    <Typography variant="body2" style={{
                        fontSize: '16px'}}>
                      {divida?.tipoContrato === "REORGPF" ? (
                        opcaoPagamento?.texto?.replace(/\((.*)\)/, "")
                      ) : (
                        opcaoPagamento?.texto
                      )}
                    </Typography>
                  </Box>
                </Grid>
                <Grid item xs={12}>
                  <Box marginX={1}>
                    <Typography
                      variant="body2"
                      style={{
                        fontSize: '16px',
                        color:
                          parcelaIndex === 0
                            // @ts-ignore
                            ? theme.palette.primary.main
                            : '#B2B2B2',
                      }}
                      align={isMobile ? 'left' : 'right'}
                    >
                      {mostrarValorDesconto(opcaoPagamento.descontoMonetario, opcaoPagamento.descontoPercentual) 
                      ? (<>{valorDesconto(opcaoPagamento.descontoMonetario,opcaoPagamento.descontoPercentual)} de desconto</>) : null}
                    </Typography>
                  </Box>
                </Grid>
                {!!opcaoPagamento?.dataVencimento && (
                  <Grid item xs={12}>
                    <Box marginX={1}>
                      <Label style={{}}>
                        Data de vencimento:{' '}
                        <strong>
                          {getFormattedDate(opcaoPagamento.dataVencimento)}
                        </strong>
                      </Label>
                    </Box>
                  </Grid>
                )}
              </Grid>
            </Paper>
          </Grid>
        );
      })}
      <When condition={showError}>
        <Grid item xs={12}>
          <FormHelperText error={true}>
            Selecione uma opção de parcelamento
          </FormHelperText>
        </Grid>
      </When>
    </Grid>
  );
}

export default ListaParcelamento;
